import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { XUXFooterComponent } from './xux-footer';
import { XUXLoaderComponent } from './xux-loader';
import { XUXDrawerModule } from './xux-drawer';
import { SearchMenuItemsPipe } from './pipes';
import { XUXNavigationComponent } from './xux-navigation';
import { XUXMenuItemComponent } from './xux-menu-item';
import { XUXMenuPinnedService } from './services/xux-menu-pinned.service';
import { XUXDrawerSidebarService } from './services/xux-drawer-sidebar.service';
import { XUXBreadcrumbNavbarComponent } from './xux-breadcrumb-navbar/xux-breadcrumb-navbar.component';
import { XVIComponentsModule } from '@app/components/xvi.components.module';
import { TranslateModule } from '@ngx-translate/core';

export * from './xux-breadcrumb-navbar';
export * from './xux-navigation';
export * from './xux-menu-item';
export * from './services';
export * from './interfaces';
export * from './pipes';
export * from './xux-drawer';
export * from './xux-footer';
export * from './xux-loader';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    XVIComponentsModule,
    XUXDrawerModule.forRoot(),
    RouterModule,
    TranslateModule,
  ],
  declarations: [
    XUXNavigationComponent,
    XUXBreadcrumbNavbarComponent,
    XUXMenuItemComponent,
    XUXFooterComponent,
    XUXLoaderComponent,
    SearchMenuItemsPipe,
  ],
  exports: [
    XUXNavigationComponent,
    XUXBreadcrumbNavbarComponent,
    XUXMenuItemComponent,
    XUXFooterComponent,
    XUXLoaderComponent,
    SearchMenuItemsPipe,
    XUXDrawerModule,
  ],
  providers: [],
})
export class XenialUxModule {
  public static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: XenialUxModule,
      providers: [XUXMenuPinnedService, XUXDrawerSidebarService],
    };
  }
}
